import { Button } from 'antd'
import { PhoneFilled, ArrowUpOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import ic_phone from 'src/assets/images/ic_phone.png'
import ic_zalo from 'src/assets/images/ic_zalo.png'
import styled, { keyframes } from 'styled-components'
import { CONTACT_CONFIG } from 'src/helpers/constants'
import { trackContactConversion } from 'src/helpers/googleAdsConversion'
const FLOAT_RIGHT = 24
const FLOAT_BOTTOM = 24
const heartbeat = keyframes`
  0% { transform: scale(1); }
  10% { transform: scale(1.08); }
  20% { transform: scale(1); }
  30% { transform: scale(1.12); }
  40% { transform: scale(1); }
  100% { transform: scale(1); }
`

const ripple = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.35);
  }
  70% {
    box-shadow: 0 0 0 16px rgba(0, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
`

const bounce = keyframes`
  0% { transform: translateY(0); }
  20% { transform: translateY(-4px); }
  40% { transform: translateY(0); }
  100% { transform: translateY(0); }
`

const ZaloButton = styled(Button)`
   background: #00000040 !important;
   border: none !important;
   border-radius: 28px !important;
   width: 56px;
   height: 56px;

   display: flex;
   align-items: center;
   justify-content: center;

   box-shadow: 0 8px 8px rgba(0, 0, 0, 0.1);

   animation: ${bounce} 3s infinite ease-in-out;

   &:hover {
      animation-play-state: paused;
   }
`
const CallButton = styled(Button)`
   background: #00000040 !important;
   border: none !important;
   border-radius: 28px !important;
   width: 56px;
   height: 56px;

   display: flex;
   align-items: center;
   justify-content: center;

   box-shadow: 0 8px 8px rgba(0, 0, 0, 0.2);

   animation: ${heartbeat} 2s infinite, ${ripple} 2s infinite;

   &:hover {
      animation-play-state: paused;
   }
`

export const FloatingActions = () => {
   const [showTop, setShowTop] = useState(false)

   useEffect(() => {
      const onScroll = () => {
         setShowTop(window.scrollY > 300)
      }

      window.addEventListener('scroll', onScroll)
      return () => window.removeEventListener('scroll', onScroll)
   }, [])

   const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
   }

   return (
      <>
         {/* ===== ACTION BUTTONS (CALL + ZALO) ===== */}
         <div
            style={{
               position: 'fixed',
               right: FLOAT_RIGHT,
               bottom: FLOAT_BOTTOM,
               zIndex: 999,
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center',
               flexDirection: 'column',
               gap: 12
            }}
         >
            {/* Call */}
            <CallButton
               shape="circle"
               size="large"
               href={`tel:${CONTACT_CONFIG.hotline}`}
               onClick={(event) => trackContactConversion(`tel:${CONTACT_CONFIG.hotline}`, event)}
            >
               <img src={ic_phone} alt="Gọi điện" style={{ width: 36, height: 36 }} />
            </CallButton>
            <ZaloButton shape="circle" size="large" href={`https://zalo.me/${CONTACT_CONFIG.zalo}`} target="_blank">
               <img src={ic_zalo} alt="Nhắn Zalo" style={{ width: 36, height: 36 }} />
            </ZaloButton>

            <ZaloButton shape="circle" size="large" href={`https://zalo.me/${CONTACT_CONFIG.hotline}`} target="_blank">
               <img src={ic_zalo} alt="Chat Zalo" style={{ width: 36, height: 36 }} />
            </ZaloButton>
            {showTop ? (
               <Button
                  shape="circle"
                  size="large"
                  icon={<ArrowUpOutlined />}
                  style={{
                     background: '#00000040',
                     width: 46,
                     height: 46,
                     alignItems: 'center',
                     justifyContent: 'center',
                     display: 'flex',
                     color: '#000000',
                     boxShadow: '0 8px 8px 0 rgba(0, 0, 0, 0.1)',
                     marginRight: 10
                  }}
                  onClick={scrollToTop}
               ></Button>
            ) : (
               <div
                  style={{
                     //   display: showTop ? 'flex' : 'none',

                     width: 46,
                     height: 46,
                     marginRight: 10
                  }}
               ></div>
            )}
         </div>
      </>
   )
}
